import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { FaixaPreco } from 'src/app/models/api/comercial/faixa-preco';

@Injectable({
  providedIn: 'root'
})
export class ApiFaixaPrecoService {
  private baseUrl = 'FaixaPreco';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<FaixaPreco[]>('');
  }
}
